import { render } from "./being_employed.vue?vue&type=template&id=4c2b581c&ts=true"
import script from "./being_employed.vue?vue&type=script&lang=ts"
export * from "./being_employed.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__